import { useEffect } from "react";
import PropTypes from "prop-types";
import MenaBanner from "./MenaBanner";

const MenaBannerContainer = ({
  visible,
  initMenaBanner,
  shopMena,
  stayHere
}) => {
  useEffect(() => {
    initMenaBanner();
  }, [initMenaBanner]);

  if (!visible) {
    return null;
  }

  return <MenaBanner onShopMena={shopMena} onStayHere={stayHere} />;
};

MenaBannerContainer.propTypes = {
  visible: PropTypes.bool.isRequired,
  initMenaBanner: PropTypes.func.isRequired,
  shopMena: PropTypes.func.isRequired,
  stayHere: PropTypes.func.isRequired
};

export default MenaBannerContainer;
